export default __webpack_public_path__ + "static/media/intervals_fr.4ec23e3c.png";